import * as Toolkit from '../toolkit/index';
import Utils from '../utils/util';
import { StageEvent } from '../message/index';

let lastUpdateTime: number = new Date().getTime();

function done(): void {
    let currentUpdateTime: number = new Date().getTime();
    let timeDis: number = currentUpdateTime - lastUpdateTime;

    if (timeDis < 600) {
        Toolkit.log({
            action: '更新',
            msgList: [
                {
                    name: 'UpdateDone 注意: 更新太频繁，性能有所下降, 距离上次更新时间相差: ',
                    value: `${timeDis}ms`
                }
            ]
        });
    }
    lastUpdateTime = currentUpdateTime;
    StageEvent.fire('UpdateDone');
}

const doneSync = done;
const doneAsync = Utils.debounce(done, 300);

export {
    doneSync,
    doneAsync
};
